import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CurrentUser } from '../public/current-user.model';
import { ajaxCall } from './ajax-call.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  // Note: this originally used `CurrentUser` with `null` as initial value.
  // We keep that to avoid surprising the rest of the app.
  private _currentUserWatch = new BehaviorSubject<CurrentUser>(null);

  // ORIGINAL API: components/services expect this.currentUserService.currentUser()
  // to return an Observable<CurrentUser>
  public currentUser(): Observable<CurrentUser> {
    return this._currentUserWatch;
  }

  constructor(private ajax: ajaxCall, private router: Router) {}

  // ORIGINAL API: many places call this.currentUserService.get()
  // to load the current user from the server.
  get(): Promise<void> {
    return this.ajax.MakeCall<CurrentUser>('/Account/Current').then(
      (x) => {
        this._currentUserWatch.next(x);
      },
      () => {
        // swallow error, leave current user as-is/null
      }
    );
  }

  // NEW helpers (for deep links and elsewhere) – non-breaking additions:

  // Synchronous access to current user value
  public get currentUserValue(): CurrentUser {
    return this._currentUserWatch.value;
  }

  public get userId(): number | null {
    return this._currentUserWatch.value
      ? this._currentUserWatch.value.userId
      : null;
  }

  public get isLoggedIn(): boolean {
    return this.userId != null;
  }

  public setCurrentUser(user: CurrentUser): void {
    this._currentUserWatch.next(user);
  }
}
